import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import axios from "axios";
import "./ContactSection.css";

const ContactSection = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        service: "Eye Exam",
        appointmentDate: "",
        appointmentTime: "",
        formType: "Main Contact Form",
    });

    const [status, setStatus] = useState({ type: "", message: "" });
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            q: "How soon can I get an appointment?",
            a: "Our business hours are Monday to Friday, 10 AM to 6 PM, Saturdays 10 AM to 4 PM.",
        },
        {
            q: "Do you accept insurance?",
            a: "Yes, we accept most major insurance plans. Contact us to confirm your provider.",
        },
        {
            q: "Can I bring my own frames?",
            a: "Absolutely. We can fit lenses into frames you already own, as long as they’re in good condition.",
        },
        {
            q: "How long does a comprehensive eye exam take?",
            a: "A full eye exam typically takes 20-30 minutes, depending on your needs.",
        },
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ type: "", message: "" });

        try {
            const res = await axios.post(
                `/send-contact-form-main`,
                formData
            );

            if (res.data.msg === "success") {
                setStatus({ type: "success", message: "Message sent successfully!" });
                setFormData({
                    name: "",
                    email: "",
                    phoneNumber: "",
                    service: "Eye Exam",
                    appointmentDate: "",
                    appointmentTime: "",
                    formType: "Main Contact Form",
                });
            } else {
                setStatus({ type: "danger", message: "Failed to send message. Try again." });
            }
        } catch (error) {
            console.error(error);
            setStatus({ type: "danger", message: "Error connecting to server." });
        }
    };

    return (
        <section className="contact-section py-5">
            <Container>
                <Row className="g-4">
                    <Col lg={6}>
                        <div className="contact-card">
                            <h5 className="section-title mb-4">
                                Send us a <span>message</span>
                            </h5>

                            {status.message && (
                                <Alert
                                    variant={status.type === "success" ? "success" : "danger"}
                                    className="mb-3"
                                >
                                    {status.message}
                                </Alert>
                            )}

                            <Form onSubmit={handleSubmit}>
                                <Row className="g-3">
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label>Full Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="Your full name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="tel"
                                                name="phoneNumber"
                                                placeholder="+1 (___) ___-____"
                                                value={formData.phoneNumber}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Email Address</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                placeholder="you@example.com"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Preferred Appointment Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="appointmentDate"
                                                value={formData.appointmentDate}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Preferred Appointment Time</Form.Label>
                                            <Form.Control
                                                type="time"
                                                name="appointmentTime"
                                                value={formData.appointmentTime}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label>Required Service</Form.Label>
                                            <Form.Select
                                                name="service"
                                                value={formData.service}
                                                onChange={handleChange}
                                            >
                                                <option className="text-black">Eye Exam</option>
                                                <option className="text-black">Prescription Update</option>
                                                <option className="text-black">Frame Consultation</option>
                                                <option className="text-black">Contact Lens Fitting</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Button type="submit" className="send-btn mt-4">
                                    Send
                                </Button>
                            </Form>
                        </div>
                    </Col>
                    <Col lg={6} className="">
                        <div className="contact-sidebar mb-lg-4">
                            <h6>
                                Contact <span>Details</span>
                            </h6>
                            <p>
                                Contact us directly via phone or email for quick assistance or to schedule an appointment.
                            </p>
                            <ul>
                                <li className="mb-2">Phone: (416) 746-2626</li>
                                <li className="mb-2">Email: info@eliteoptix.ca</li>
                                <li className="mb-2">Located at 2930 Islington Ave, Toronto, Ontario M9L2K5</li>
                            </ul>

                        </div>
                        <div className="contact-sidebar mb-lg-4 ">
                            <h6>
                                Insurance & <span>Payments</span>
                            </h6>
                            <p>
                                We’ll guide you on direct billing and claims. Bring your current
                                prescription — or book a comprehensive eye exam in-house.
                            </p>
                            <ul>
                                <li className="mb-2">Direct billing (where available)</li>
                                <li className="mb-2">All major cards accepted</li>
                                <li className="mb-2">HSAs & FSAs</li>
                            </ul>
                        </div>

                    </Col>
                </Row>

                <Row className="mt-2 g-4">

                    <Col>
                        <div className="contact-sidebar">
                            <h6>FAQs</h6>
                            <div className="faq">
                                {faqs.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`faq-item border_bottom ${openIndex === index ? "open" : ""}`}
                                    >
                                        <p
                                            className="faq-q"
                                            onClick={() => toggleFAQ(index)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {item.q}
                                        </p>
                                        {openIndex === index && (
                                            <p className="faq-a">{item.a}</p>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ContactSection;
